// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__xl9Ie","content":"Consent_content__3tGrJ","footer":"Consent_footer__3KIIb"};